export const getIdAndTicketFromOriginalFileLocation = (originalFileLocation: string):string => {
    const lastSlashIndex = originalFileLocation.lastIndexOf('/');
    const filenameWithQuery = originalFileLocation.substring(lastSlashIndex + 1);
    
    return filenameWithQuery;
}